module.exports = __webpack_public_path__ + "static/media/ClipBoardPlus.ac8e179c.svg";